import "./style.scss";

type LoadingProps = {
  logo?: boolean;
};

const Loading = ({ logo = false }: LoadingProps): JSX.Element => (
  <div className="loading">
    {logo && (
      <div id="logo">
        <img src="/assets/icons/logo.svg" alt="logo" />
      </div>
    )}

    <div id="spinner">
      <div className="bounce1" />

      <div className="bounce2" />

      <div className="bounce3" />
    </div>
  </div>
);

export default Loading;
